import { h, render, Component } from 'preact';
import { classNames, formatNumber } from '../utils/utils';
import { PlanService } from '../plan-service.service';
import TxrCollapseToggler from './txr-collapse-toggler';

class TxrPlanCompare extends Component {
    state = {
        plan1: {},
        plan2: {},
        plan3: {},
        plan4: {},
        groups: [],
    }

    toggle(group) {
        group.isCollapsed = !group.isCollapsed;
        this.forceUpdate();
    }
    componentDidMount() {
         const plans = new PlanService();
         this.state.plan1 = plans.getPlan('basic');
         this.state.plan2 = plans.getPlan('starter');
         this.state.plan3 = plans.getPlan('corporate');
         this.state.plan4 = plans.getPlan('enterprise');
         this.state.groups = [
            {
                name: 'Basic Messaging Features',
                isCollapsed: true,
                rows: [
                    {
                        name: '2-Way Texting (Conversations)',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Landline, VOIP Texting',
                        description: 'Use your existing office phone number(s) for texting without affecting voice services.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Mass Texting',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Picture Messaging (MMS)',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Link Sharing',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Message Templates',
                        description: 'Type your message once, save it to use repeatedly across users.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Emoji Keyboard',
                        description: '',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Multi-Language Support',
                        description: 'Send and receive texts in any language.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Resolve + Unresolve',
                        description: 'Mark whether a text needs your attention, like a read vs. unread email.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Delivery Status',
                        description: 'We\'ll tell you if your text was delivered, or if there were any errors.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Forwarding',
                        description: 'Manually forward a text to another number.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Escalation',
                        description: 'Automatically forward a text to another number after a set number of minutes.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Message Tags',
                        description: 'Tag individual messages with custom labels, create reports to view all.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Download + Print',
                        description: '',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Permanent Records',
                        description: '',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Search + Filter',
                        description: '',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Reporting',
                        description: 'Pull unlimited reports on usage, opt outs, and more with custom dates.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Mobile Apps',
                        description: 'Take Text Request everywhere work takes you with our iOS and Android apps.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Spam Scanner',
                        description: 'We\'ll tell you if your BCC group (mass) message has potential to be flagged as spam before sending.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Subscriber Management',
                        description: 'Manage contact opt-ins and opt-outs for easy messaging compliance.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    }
                ]
            },
            {
                name: 'Advanced Messaging Features',
                rows: [
                    {
                        name: 'Sequences',
                        class: 'column__image',
                        description: 'A series of messages scheduled around a date that is important to you and your customers.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Reviews',
                        class: 'column__image',
                        description: 'Connect your Google and Facebook business profiles to earn, reply to, and track online reviews. Priced per 25 dashboards.',
                        column1: { text: '$50/mo', class: 'column__price' },
                        column2: { text: '$50/mo', class: 'column__price' },
                        column3: { text: '$50/mo', class: 'column__price' },
                        column4: { text: '$50/mo', class: 'column__price' },
                    },
                    {
                        name: 'Payments',
                        class: 'column__image',
                        description: 'Request and receive secure payments through text. Transaction fee based on volume.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Peer to Peer Texting',
                        description: 'Send one-to-one messages at scale.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Scheduled Messages',
                        description: 'Schedule your messages to send once at a specific time or automatically on a repeating basis.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Location Requests',
                        description: 'Request a contact\'s location, and have them send you a pin with their exact address.',
                        class: 'column__image',
                        column1: { text: '$15/mo', class: 'column__price' },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Chrome Extension',
                        description: 'Text from any page on the web with our browser extension.',
                        class: 'column__image',
                        column1: { text: '$15/mo', class: 'column__price' },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Custom Merge',
                        description: 'Include personalized info like name and date when texting multiple contacts at once.',
                        class: 'column__image',
                        column1: { text: '$15/mo', class: 'column__price' },
                        column2: { text: '$15/mo', class: 'column__price' },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'SMS Chat',
                        description: 'Spark inbound conversations with our web chat widget.',
                        class: 'column__image',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    }
                ]
            },
            {
                name: 'Automations',
                rows: [
                    {
                        name: 'Call Forwarding',
                        class: 'column__image',
                        descriptionItalicPrefix: 'Exclusive to text-only numbers. ',
                        description: 'Seamlessly forwards callers to a voice-enabled phone number you provide. Priced per account, up to 25 dashboards.',
                        column1: { text: '$25/mo', class: 'column__price' },
                        column2: { text: '$25/mo', class: 'column__price' },
                        column3: { text: '$25/mo', class: 'column__price' },
                        column4: { text: '$25/mo', class: 'column__price' },
                    },
                    {
                        name: 'Automated Greeting',
                        class: 'column__image',
                        descriptionItalicPrefix: 'Exclusive to text-only numbers. ',
                        description: 'Informs callers they\'ve reached a text-only number and provides your voice-enabled number to call instead.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Autoresponder',
                        class: 'column__image',
                        description: 'Automatic replies for out of office, or any other reason.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Keywords',
                        class: 'column__image',
                        description: 'A word that contacts text to opt in or receive info. Use to create and manage subscribers.',
                        column1: { text: '$15/mo', class: 'column__price' },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: '3rd Party Integrations',
                        class: 'column__image',
                        description: 'Connect Text Request to tools you already use. View our Integrations page for the full list.',
                        column1: { check: false },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'API Access',
                        class: 'column__image',
                        description: 'Use our API to build your own solution or integration.',
                        column1: { text: '$50/mo', class: 'column__price' },
                        column2: { text: '$50/mo', class: 'column__price' },
                        column3: { text: '$50/mo', class: 'column__price' },
                        column4: { check: true },
                    }
                ]
            },
            {
                name: 'Contact Management',
                isCollapsed: true,
                rows: [
                    {
                        name: 'Unlimited Contacts',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Unlimited Contact Groups',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Unlimited Group Sizes',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Import + Export',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Custom Fields',
                        class: 'column__image',
                        description: 'Add custom fields to each contact record for birthdays, notes, any criteria you care about.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Contact Stats',
                        class: 'column__image',
                        description: 'See how engaged each contact is with your messages.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Contact Tags',
                        class: 'column__image',
                        description: 'Custom contact labels to filter or quickly identify contacts.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Filter + Sort',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Contact Status',
                        class: 'column__image',
                        description: 'Tells you whether a contact is active, opted out, or blocked.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    }
                ]
            },
            {
                name: 'User Management',
                isCollapsed: true,
                rows: [
                    {
                        name: 'Unlimited Users',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Tiered Permissions',
                        class: 'column__image',
                        description: 'Give each user Administrator (everything), Manager (all but billing), or CSR (limited) access.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Typing Notifications',
                        class: 'column__image',
                        description: 'Know when another user is responding to a contact.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Custom Signatures',
                        class: 'column__image',
                        description: 'Each user can create custom signatures, just like email.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'New Message Notifications',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Name + Time Stamps',
                        class: 'column__image',
                        description: 'Every sent text shows the user who sent it, the time and day they sent it.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'User Profiles',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Custom Dashboard Views',
                        class: 'column__image',
                        description: 'Change how and which messages are displayed to optimize your workday.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    }
                ]
            },
            {
                name: 'Account Management',
                rows: [
                    {
                        name: 'Billing + Invoice Management',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: '10DLC Verified Sending',
                        class: 'column__image',
                        description: 'We\'ll register your number with carriers for increased delivery and speed.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Dedicated Support Rep',
                        class: 'column__image',
                        description: '',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Multi-Factor Authentication (MFA)',
                        class: 'column__image',
                        description: 'Protect your account and company by using SMS verification to login.',
                        column1: { check: true },
                        column2: { check: true },
                        column3: { check: true },
                        column4: { check: true },
                    },
                    {
                        name: 'Single Sign-on (SSO)',
                        class: 'column__price',
                        description: 'Manage logins for all users on your account through Microsoft and Google.',
                        column1: { text: '$250/mo' },
                        column2: { text: '$250/mo' },
                        column3: { text: '$250/mo' },
                        column4: { text: '$250/mo' },
                    },                    
                    {
                        name: 'Additional Dashboards',
                        class: 'column__price',
                        description: 'Text from multiple lines under the same account.',
                        column1: { text: '$10/mo' },
                        column2: { text: '$10/mo' },
                        column3: { text: '$10/mo' },
                        column4: { text: '$10/mo' },
                    },
                    {
                        name: 'HIPAA Compliant Account',
                        class: 'column__price',
                        description: 'Specialized account for patient texting. Comes with Business Associate Agreement upon request.',
                        column1: { text: '$50/mo' },
                        column2: { text: '$50/mo' },
                        column3: { text: '$50/mo' },
                        column4: { text: '$50/mo' },
                    },
                    {
                        name: 'Additional Texts',
                        class: 'column__price',
                        description: 'Your per text rate if you go over your monthly base text volume.',
                        column1: { text: this.state.plan1.addTexts },
                        column2: { text: this.state.plan2.addTexts },
                        column3: { text: this.state.plan3.addTexts },
                        column4: { text: this.state.plan4.addTexts }
                    }
                ]
            }

        ];
         this.forceUpdate();
    }
    render() {
        return (
            <div class="txr-plan-compare">

                <div class="plan-compare__row plan-compare__row-header">
                    <div class="plan-compare__column header"></div>
                    <div class="plan-compare__column plan1">
                        <span class="plan-compare__name">BASIC</span>
                        <span class="plan-compare__price">${this.state.plan1.newPrice}</span>
                        <span class="plan-compare__period">USD/month</span>
                    </div>
                    <div class="plan-compare__column plan2">
                        <span class="plan-compare__name">STARTER</span>
                        <span class="plan-compare__price">${this.state.plan2.newPrice}</span>
                        <span class="plan-compare__period">USD/month</span>
                    </div>
                    <div class="plan-compare__column plan3">
                        <span class="plan-compare__name">CORPORATE</span>
                        <span class="plan-compare__price">${this.state.plan3.newPrice}</span>
                        <span class="plan-compare__period">USD/month</span>
                    </div>
                    <div class="plan-compare__column plan4">
                        <span class="plan-compare__name">ENTERPRISE<br />& HIGH VOLUME</span>
                        <span class="plan-compare__name-help">starting at</span>
                        <span class="plan-compare__price">${this.state.plan4.newPrice}</span>
                        <span class="plan-compare__period">USD/month</span>
                    </div>
                </div>
                <div class="plan-compare__row">
                    <div class="plan-compare__column header">
                        <div class="column__subtitle">Included Texts</div>
                        <div class="column__text">
                          The number of texts included in your plan each month.
                        </div>
                    </div>
                    <div class="plan-compare__column plan1">
                        1,000
                    </div>
                    <div class="plan-compare__column plan2">
                        2,500
                    </div>
                    <div class="plan-compare__column plan3">
                        6,500
                    </div>
                    <div class="plan-compare__column plan4">
                        20,000
                    </div>
                </div>
                <div class="plan-compare__row">
                    <div class="plan-compare__column header">
                        <div class="column__subtitle">Included Dashboards</div>
                        <div class="column__text">
                        1 dashboard = 1 text line with all plan features. You can text from multiple lines/dashboards under your account.
                        </div>
                    </div>
                    <div class="plan-compare__column plan1">
                        1
                    </div>
                    <div class="plan-compare__column plan2">
                        2
                    </div>
                    <div class="plan-compare__column plan3">
                        5
                    </div>
                    <div class="plan-compare__column plan4">
                        10
                    </div>
                </div>
                {
                    this.state.groups.map(group =>
                        <div class={classNames({ 'plan-compare__section': true, 'expandable-section__expanded': !group.isCollapsed })}>
                            <div class="plan-compare__row plan-compare__row-subsection txr-pointer" onClick={() => this.toggle(group)}>
                                <div class="plan-compare__column header">
                                    <div class="expandable-section__header">
                                        <TxrCollapseToggler isExpanded={!group.isCollapsed}></TxrCollapseToggler>{group.name}
                                    </div>
                                </div>
                                <div class="plan-compare__column plan1">

                                </div>
                                <div class="plan-compare__column plan2">

                                </div>
                                <div class="plan-compare__column plan3">

                                </div>
                                <div class="plan-compare__column plan4">
                                </div>
                            </div>
                            <div class="expandable-section__content">
                                {
                                    group.rows.map(row =>
                                        <div class={'plan-compare__row ' + row.class}>
                                            <div class="plan-compare__column header">
                                                <div class="column__subtitle">{row.name}</div>
                                                <div class="column__text">
                                                    <span class="column__text-prefix-italic">{row.descriptionItalicPrefix}</span>{row.description}
                                                </div>
                                            </div>
                                            <div class={'plan-compare__column plan1 '+ row.column1.class}>
                                                <img class={classNames({ 'column__image': true, 'yes': row.column1.check })}  alt="yes/no"/>
                                                <div class="column__price">
                                                    {row.column1.text}
                                                </div>
                                            </div>
                                            <div class={'plan-compare__column plan2 '+ row.column2.class}>
                                                <img class={classNames({ 'column__image': true, 'yes': row.column2.check })} src="/images/pricing/icn-yes.svg" alt="yes"/>
                                                <div class="column__price">
                                                    {row.column2.text}
                                                </div>
                                            </div>
                                            <div class={'plan-compare__column plan3 '+ row.column3.class}>
                                                <img class={classNames({ 'column__image': true, 'yes': row.column3.check })} src="/images/pricing/icn-yes.svg" alt="yes"/>
                                                <div class="column__price">
                                                    {row.column3.text}
                                                </div>

                                            </div>
                                            <div class={'plan-compare__column plan4 '+ row.column4.class}>
                                                <img class={classNames({ 'column__image': true, 'yes': row.column4.check })} src="/images/pricing/icn-yes.svg" alt="yes"/>
                                                <div class="column__price">
                                                    {row.column4.text}
                                                </div>

                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )
                }
                <div class="plan-compare__row">
                    <div class="plan-compare__column header">
                    </div>
                    <div class="plan-compare__column plan1">
                        <a class="txr-button-link" href="/purchase?plan=basic">
                            <button class="right-details__button txr-button txr-primary-button txr-width180 txr-content-width90" type="button">
                                <span class="txr-button__content">BASIC<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                            </button>
                        </a>
                    </div>
                    <div class="plan-compare__column plan2">
                        <a class="txr-button-link" href="/purchase?plan=starter">
                            <button class="right-details__button txr-button txr-primary-button txr-width180 txr-content-width90" type="button">
                                <span class="txr-button__content">STARTER<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                            </button>
                        </a>
                    </div>
                    <div class="plan-compare__column plan3">
                        <a class="txr-button-link" href="/purchase?plan=corporate">
                            <button class="right-details__button txr-button txr-primary-button txr-width180" type="button">
                                <span class="txr-button__content">CORPORATE<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                            </button>
                        </a>
                    </div>
                    <div class="plan-compare__column plan4">
                        <a class="txr-button-link" href="/purchase?plan=enterprise">
                            <button class="right-details__button txr-button txr-primary-button txr-width180" type="button">
                                <span class="txr-button__content">ENTERPRISE<i class="txr-button__angle-icon fal fa-angle-right"></i></span>
                            </button>
                        </a>
                    </div>
                </div>
            </div>


        )
    }


}

export default TxrPlanCompare;